import { useCallback, useEffect, useState } from 'react';
import { DEFAULT_ANCHOR } from '../lib/geo';

// Bumped to v2 when the preset anchor moved -- a stale stored copy of the old
// preset must not survive.
const STORAGE_KEY = 'hud-anchor-v2';

/**
 * The anchor the drift distance is measured from. Editable, and remembered per
 * browser so a watch position survives a reload -- but never written back to
 * the device: this app is read-only.
 */
export function useAnchor() {
  const [anchor, setAnchor] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (!stored) return DEFAULT_ANCHOR;

      const parsed = JSON.parse(stored);
      if (typeof parsed?.lat === 'number' && typeof parsed?.lon === 'number') return parsed;
    } catch (e) {}

    return DEFAULT_ANCHOR;
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(anchor));
    } catch (e) {}
  }, [anchor]);

  const reset = useCallback(() => setAnchor(DEFAULT_ANCHOR), []);

  return { anchor, setAnchor, reset };
}
